
import { InteractionRequiredAuthError, SilentRequest } from "@azure/msal-browser";
import { IMsalContext } from "@azure/msal-react";

export const getAccessToken = async (msalContext: IMsalContext, data: SilentRequest) => {
   const result = await msalContext.instance
    .acquireTokenSilent(data)
    .catch(e => {
        if (e instanceof InteractionRequiredAuthError) {
            return msalContext.instance.acquireTokenRedirect({ scopes: data.scopes });
        }
    });

    if (result && result.accessToken && result.accessToken !== undefined) {
        return result.accessToken;
    }

   return null;
}

export const getAuthorizationHeader = (accessToken: string) => ({ Authorization: `Bearer ${accessToken}` });